import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  // CardContent,
  Typography,
  Chip,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import SquareFootIcon from "@mui/icons-material/SquareFoot";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import img1 from "../../pictures/img1.jpg";
import img2 from "../../pictures/img3.jpg";
import img3 from "../../pictures/img4.jpg";

function RevealOnScroll({ children, direction = "left" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.25 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",
        height: "100%",
        opacity: visible ? 1 : 0,
        transform: visible
          ? "translateX(0)"
          : direction === "left"
            ? "translateX(-60px)"
            : "translateX(60px)",
        transition: "opacity 0.7s ease, transform 0.7s ease",
        willChange: "opacity, transform",
      }}
    >
      {children}
    </Box>
  );
}

function AnimatedCard({ children, animationType }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.25 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",
        height: "100%",
        opacity: visible ? 1 : 0,
        transform: visible ? "scale(1)" : "scale(0.9)",
        transition: "opacity 0.8s ease, transform 0.8s ease",
        animation: visible ? `${animationType} 1.2s ease` : "none",
        willChange: "opacity, transform",
      }}
    >
      {children}
    </Box>
  );
}

function CompletedProjects() {
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  const projects = [
    {
      id: 1,
      clientName: "Mr. Krishnan",
      location: "Korattur",
      category: "Individual House",
      size: "5000 Sq.ft",
      structure: "Stilt + 2 Floors",
      status: "Completed",
      description:
        "An individual house project developed at Korattur with a stilt + 2 floor structure across approximately 5000 sq.ft. The work focused on organized planning, structural execution, and neat residential construction standards.",
      images: [img1, img2, img3],
    },
    {
      id: 2,
      clientName: "Mr. G. Anil Agarwal",
      location: "Kilpauk Garden",
      category: "Residential",
      size: "10000 Sq.ft",
      structure: "Stilt + 3 Floors",
      status: "Completed",
      description:
        "A large residential development at Kilpauk Garden executed with stilt + 3 floors over around 10000 sq.ft. The project involved systematic construction management, quality supervision, and premium residential execution.",
      images: [img2, img3, img1],
    },
    {
      id: 3,
      clientName: "Mr. Ganesh",
      location: "Mogappair",
      category: "Residential",
      size: "2400 Sq.ft",
      structure: "Ground + 2 Floors",
      status: "Completed",
      description:
        "A residential building project in Mogappair planned as a ground + 2 floor structure over 2400 sq.ft. The work covered practical space planning, structural development, and clean finishing for modern family use.",
      images: [img3, img1, img2],
    },
    {
      id: 4,
      clientName: "Mr. D.V. Balachandran",
      location: "Nolambur Phase-2",
      category: "Independent Duplex House",
      size: "6000 Sq.ft",
      structure: "Stilt + 3 Floors",
      status: "Completed",
      description:
        "An independent duplex house at Nolambur Phase 1 designed with a stilt + 3 floor configuration across about 6000 sq.ft. The project combined residential comfort, strong structural work, and a refined duplex layout approach.",
      images: [img1, img3, img2],
    },
    {
      id: 5,
      clientName: "Mr. Sudharsan Khemka",
      location: "Redhills",
      category: "Commercial Warehouse",
      size: "12000 Sq.ft",
      structure: "Commercial Project",
      status: "Completed",
      description:
        "A commercial warehouse project undertaken in Red Hills with a built-up area of nearly 12000 sq.ft. The work emphasized functionality, durable construction methods, and effective planning for commercial storage operations.",
      images: [img2, img1, img3],
    },
    {
      id: 6,
      clientName: "Mr. Sudharsanan Khemka",
      location: "Allamathi",
      category: "Warehouse",
      size: "6000 Sq.ft",
      structure: "Commercial Project",
      status: "Completed",
      description:
        "A warehouse construction project at Allamathi developed across 6000 sq.ft. The execution focused on structural reliability, utility-driven layout planning, and efficient commercial project delivery.",
      images: [img3, img2, img1],
    },
    {
      id: 7,
      clientName: "Veyem Engineering Service",
      location: "Royapuram / Egmore / Chetpet Railway Station",
      category: "Southern Railway Building Construction Contract Work",
      size: "Building Construction",
      structure: "Contract Project",
      status: "Completed",
      description:
        "Building construction works carried out under Southern Railway contract assignments at locations including Egmore and Chetpet Railway Station. The project scope involved disciplined execution, coordination, and contract-based construction support.",
      images: [img1, img2, img3],
    },
    {
      id: 8,
      clientName: "Chakra Foundation",
      location: "Srinivasa Milk Product, Kallikuppam",
      category: "Commercial Projects",
      size: "10000 Sq.ft",
      structure: "G + 3 Floor",
      status: "Completed",
      description:
        "Commercial construction projects executed for Chakra Foundation at Pallikuppam and Puzhal, covering approximately 10000 sq.ft and 6000 sq.ft. These works involved multi-floor commercial development with strong attention to planning, execution quality, and functional design.",
      images: [img2, img3, img1],
    },
    {
      id: 9,
      clientName: "Chakra Foundation",
      location: "Pudhur",
      category: "Commercial Projects",
      size: "6000 Sq.ft",
      structure: "Ground + 3 Floor",
      status: "Completed",
      description:
        "Commercial construction projects executed for Chakra Foundation at Pallikuppam and Puzhal, covering approximately 10000 sq.ft and 6000 sq.ft. These works involved multi-floor commercial development with strong attention to planning, execution quality, and functional design.",
      images: [img3, img1, img2],
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevState) => {
        const newState = { ...prevState };
        projects.forEach((project) => {
          const currentIndex = prevState[project.id] || 0;
          newState[project.id] = (currentIndex + 1) % project.images.length;
        });
        return newState;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [projects]);

  const handlePrevImage = (projectId) => {
    setCurrentImageIndex((prevState) => {
      const currentIndex = prevState[projectId] || 0;
      const newIndex =
        currentIndex === 0
          ? projects.find((p) => p.id === projectId).images.length - 1
          : currentIndex - 1;
      return { ...prevState, [projectId]: newIndex };
    });
  };

  const handleNextImage = (projectId) => {
    setCurrentImageIndex((prevState) => {
      const currentIndex = prevState[projectId] || 0;
      const newIndex =
        (currentIndex + 1) %
        projects.find((p) => p.id === projectId).images.length;
      return { ...prevState, [projectId]: newIndex };
    });
  };

  return (
    <Box
      sx={{
        py: 12,
        background:
          "linear-gradient(135deg, #dbe6ff 0%, #dce5ff 50%, rgb(167, 194, 255) 100%)",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Background glow */}
      <Box
        sx={{
          position: "absolute",
          top: -120,
          left: -100,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(33,150,243,0.12) 0%, rgba(33,150,243,0) 70%)",
          filter: "blur(18px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -100,
          right: -80,
          width: 280,
          height: 280,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(13,6,81,0.10) 0%, rgba(13,6,81,0) 70%)",
          filter: "blur(20px)",
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2 }}>
        <Typography
          variant="h4"
          textAlign="center"
          fontWeight="bold"
          mb={1.5}
          sx={{
            color: "#08027d",
            fontSize: { xs: "1.9rem", md: "2.8rem" },
          }}
        >
          Completed Projects
        </Typography>

        <Typography
          textAlign="center"
          sx={{
            maxWidth: 850,
            mx: "auto",
            mb: 6,
            color: "rgba(13, 6, 81, 0.72)",
            lineHeight: 1.8,
          }}
        >
          A showcase of successfully completed residential, duplex, warehouse,
          commercial, and contract-based construction projects delivered with
          quality, planning, and professionalism.
        </Typography>

        <Grid container spacing={4}>
          {projects.map((project, index) => {
            const reverse = index % 2 === 1;

            return (
              <Grid item xs={12} key={project.id}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      md: reverse ? "row-reverse" : "row",
                    },
                    gap: 3,
                    alignItems: "stretch",
                  }}
                >
                  {/* Image side */}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <AnimatedCard animationType="fadeIn">
                      <Card
                        sx={{
                          height: "100%",
                          borderRadius: 4,
                          overflow: "hidden",
                          boxShadow: "0 18px 45px rgba(13,6,81,0.12)",
                        }}
                      >
                        <Box sx={{ position: "relative" }}>
                          <Box
                            component="img"
                            src={
                              project.images[currentImageIndex[project.id] || 0]
                            }
                            alt={project.clientName}
                            sx={{
                              width: "100%",
                              height: { xs: 240, md: 320 },
                              objectFit: "cover",
                              display: "block",
                            }}
                          />

                          <Box
                            onClick={() => handlePrevImage(project.id)}
                            sx={{
                              position: "absolute",
                              left: 14,
                              top: "50%",
                              transform: "translateY(-50%)",
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                              bgcolor: "rgba(255,255,255,0.18)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                          >
                            <ArrowBackIcon fontSize="small" />
                          </Box>

                          <Box
                            onClick={() => handleNextImage(project.id)}
                            sx={{
                              position: "absolute",
                              right: 14,
                              top: "50%",
                              transform: "translateY(-50%)",
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                              bgcolor: "rgba(255,255,255,0.18)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                          >
                            <ArrowForwardIcon fontSize="small" />
                          </Box>
                        </Box>
                      </Card>
                    </AnimatedCard>
                  </Box>

                  {/* Text side */}
                  <Box sx={{ flex: 1, minWidth: 0, display: "flex" }}>
                    <AnimatedCard
                      animationType={reverse ? "slideInRight" : "slideInLeft"}
                    >
                      <Card
                        sx={{
                          height: "100%",
                          width: "100%",
                          borderRadius: 5,
                          position: "relative",
                          overflow: "hidden",
                          p: { xs: 2.5, md: 4 },
                          background: `
                            linear-gradient(145deg, rgba(174, 192, 255, 0.92), rgba(244,247,255,0.78))
                          `,
                          backdropFilter: "blur(18px)",
                          border: "1px solid rgba(13,6,81,0.10)",
                          boxShadow: `
                            0 18px 50px rgba(13,6,81,0.10),
                            0 2px 8px rgba(13,6,81,0.06)
                          `,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          "&:before": {
                            content: '""',
                            position: "absolute",
                            inset: 0,
                            background:
                              "radial-gradient(circle at top right, rgba(33,150,243,0.12), transparent 35%)",
                            pointerEvents: "none",
                          },
                          "&:after": {
                            content: '""',
                            position: "absolute",
                            inset: "12px",
                            borderRadius: 4,
                            border: "1px solid rgba(13,6,81,0.05)",
                            pointerEvents: "none",
                          },
                        }}
                      >
                        <Box sx={{ position: "relative", zIndex: 1 }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={2}
                          >
                            <Chip
                              label="Completed Project"
                              size="small"
                              sx={{
                                bgcolor: "rgba(13,6,81,0.08)",
                                color: "#0d0651",
                                fontWeight: 700,
                                letterSpacing: "0.04em",
                                borderRadius: "999px",
                              }}
                            />
                            <Chip
                              label={project.structure}
                              size="small"
                              sx={{
                                bgcolor: "rgba(33,150,243,0.10)",
                                color: "#0d0651",
                                fontWeight: 700,
                                borderRadius: "999px",
                              }}
                            />
                          </Stack>

                          <Typography
                            variant="h5"
                            fontWeight={900}
                            sx={{
                              color: "#0d0651",
                              mb: 1.5,
                              letterSpacing: "-0.02em",
                            }}
                          >
                            {project.clientName}
                          </Typography>

                          <Typography
                            sx={{
                              color: "rgba(13,6,81,0.72)",
                              lineHeight: 1.7,
                              mb: 2.5,
                              fontSize: { xs: "0.95rem", md: "1rem" },
                            }}
                          >
                            {project.description}
                          </Typography>

                          <Stack direction="row" flexWrap="wrap" gap={1.2}>
                            <Chip label={project.location} size="small" variant="outlined" />
                            <Chip label={project.category} size="small" variant="outlined" />
                            <Chip label={project.size} size="small" variant="outlined" />
                          </Stack>
                        </Box>
                      </Card>
                    </AnimatedCard>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>

      <style>{`
        @keyframes projectFloat {
          0%, 100% {
            transform: translateY(0px) rotateX(5deg);
          }
          50% {
            transform: translateY(-12px) rotateX(2deg);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          *, *::before, *::after {
            animation: none !important;
            transition: none !important;
          }
        }
      `}</style>
    </Box>
  );
}

export default CompletedProjects;
